export type ArrayError = {
  controlId: string | undefined;
  text: string;
};

export type ErrorData = {
  major?: string;
  amount?: ArrayError[];
  jobTitle?: ArrayError[];
  incomeType?: string;
  companyName?: ArrayError[];
  industry?: string;
  natureOfBusiness?: string;
};

export enum InputType {
  AMOUNT = 'amount',
  INCOME = 'income',
  EMPLOYED = 'employed',
  SELF_EMPLOYED = 'self-employed',
}

export enum InputSubType {
  JOB_TITLE = 'Job Title',
  COMPANY_NAME = 'Company Name',
  INDUSTRY = 'Industry',
  NATURE_OF_BUSINESS = 'Nature of business',
}

export type SOFOption = {
  controlId: string;
  text: string;
  inputType?: InputType;
};

export type SOFQuestion = {
  id: string;
  title: string;
  subtitle?: string;
  required: boolean;
} & (
  | {
      type: 'checkbox';
      options: SOFOption[];
      controlId?: never;
    }
  | {
      type: 'text';
      options?: never;
      controlId: string;
    }
);

export type SOFPayloadAnswer = {
  answer: string;
  amount?: string;
  incomeType?: string;
  jobTitle?: string;
  companyName?: string;
  industry?: string;
  natureOfBusiness?: string;
  controlId: string;
};

export type SOFPayload = Record<
  SOFQuestion['id'],
  Record<Required<SOFQuestion>['controlId'], SOFPayloadAnswer>
>;
